module.exports = __webpack_public_path__ + "images/a4f4401.png";